import React , { useState ,  useEffect } from 'react';
import './Register.scss';
import { Formik ,  Form , Field } from 'formik';
import LoginVideo from '../../Videos/login-vid.mp4';
import { motion } from "framer-motion";
import { LoginValidation, RegisterValidation } from '../Validation/Validation';
import { useNavigate } from 'react-router-dom';
import userProfile from '../../images/login-images/user-profile.svg'
import OTPInput from "otp-input-react";
import axios from 'axios';
import toast from 'react-hot-toast';



const Register = () => {

  const navigate = useNavigate()

  const apiUrl = 'https://code-sgbackend.vercel.app/api/v1/auth'

  const [passwordHandler , setPasswordHandler] = useState(false);
  const [profileImage , setProfileImage] = useState(null);
  const [uploadedFile , setUploadedFile] = useState(null);
  const [otpHandler , setOtpHandler] = useState(false);
  const [otpInput, setOtpInput] = useState('');
  const [resendToggle , setResendToggle] = useState(false);
  const [userMail , setUserMail] = useState('')

  const [timeLeft, setTimeLeft] = useState(59); 

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer); 
    } else {
      setResendToggle(true)
    }
  }, [timeLeft]);

  const handleResend = () => {
    setTimeLeft(59);
    setResendToggle(false);
  };

  const registerValues = {
    userName: '',
    mobileNumber: '',
    email:'',
    password:'',
  }




  const [section, setSection] = useState(0);
  const [isBack, setIsBack] = useState(false);
  const changeSection = (i, isBack) => {
    isBack ? setIsBack(true) : setIsBack(false);
    setSection(i);
  };


  const numbersOnlyInput = (e) => {
    var key = e.key;
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      e.preventDefault();
    }
    else {
      console.log("You pressed a key: " + key);
    }
  }


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setUploadedFile(file)
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setProfileImage(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRegister = async (values) => {
    const formValue = new FormData();
    formValue.append('userName' , values.userName);
    formValue.append('mobileNumber' , values.mobileNumber);
    formValue.append('email' , values.email);
    formValue.append('profileImage' , uploadedFile);
    formValue.append('password' , values.password);
    try {
      await axios.post(`${apiUrl}/user` , formValue)
      .then((res) => {
        if(res) {
          setOtpHandler(true);
          toast.success('OTP Sent Successfully, Please Check Inbox');
          setUserMail(res?.data?.data?.user?.email)
          console.log(res , 'userreg-res')
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.error('Error occurred during POST request:', err);
        setOtpHandler(false)
      });
    } catch (error) {
      console.log(error)
    }
    
  }


  const otpHandleFetch = async () => {
    const obj = {
      email: userMail,
      otp: Number(otpInput)
    }
    console.log(obj)
   try {
    await axios.post(`${apiUrl}/verifyOtp` , obj)
    .then((res) => {
      if(res) {
        toast.success('Account Registered Successfully, Please Login');
        navigate('/login')
        console.log(res , 'otp-res')
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message);
      console.error('Error occurred during POST request:', err);
    });
   } catch (error) {
    console.log(error)
   }
  }


  return (
    <div className="Login main-login-screen bg-hometext-white h-screen">
      <div className="grid grid-cols-2 h-full">
        <div className="left-login-video-sec  overflow-hidden h-full">
          <video src={LoginVideo} autoPlay muted loop controls={false} width="100%" className='h-full object-cover' height="100%"></video>
        </div>
        <div className="right-forms-section-login flex items-center justify-center">
          {otpHandler == false ?  
            <div className="inner-form-section-login max-w-[80%] w-full py-10">
                <div className="top-header-login mb-10">
                  <h2 className='text-homeblack text-6xl font-DmSans leading-normal font-bold mb-2'>Register</h2>
                  <p className='text-homeblack font-DmSans'>& Enjoy exclusive fetaures and many more</p>
                </div>
                {/* <div className="w-full h-screen flex flex-col gap-4  items-center justify-center">
                  <div className="w-full flex items-center justify-around gap-4">
                    {[0, 1, 2].map((i) => (
                      <div
                        key={i}
                        className={`${
                          (section < i && "bg-gray-100 dark:bg-gray-900  h-2 ") ||
                          (section > i && "bg-green-500 dark:bg-green-500  h-2") ||
                          "p-0 bg-green-100 dark:bg-green-900"
                        }  w-full rounded flex items-center justify-center transition-bg duration-300 ease-in-out`}
                      >
                        {section === i && (
                          <motion.div
                          
                            className="w-full h-2 rounded flex items-center justify-center bg-green-100 dark:bg-green-900"
                            layoutId="bg"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="relative inline-block h-full w-full  overflow-hidden text-center align-middle border border-gray-200 dark:border-gray-700 rounded-2xl transition-all">
                    {section !== 0 && (
                        <button
                          onClick={() => changeSection(section - 1, true)}
                          className="absolute z-10 left-10 top-5 inline-flex items-center justify-center gap-2 hover:underline"
                        >
                          Back
                        </button>
                    )}

                    {section === 0 && (
                      <motion.div
                        style={isBack ? { x: -200, opacity: 0 } : { x: 200, opacity: 0 }}
                        animate={
                          isBack
                            ? { translateX: 200, opacity: 1 }
                            : { translateX: -200, opacity: 1 }
                        }
                        className="my-16"
                      >
                        <div className="h-40">section 0</div>
                        <button
                          onClick={() => changeSection(1, false)}
                          className="w-32 h-10 bg-black text-white rounded-lg text-xl"
                        >
                          Continue
                        </button>
                      </motion.div>
                    )}

                    {section === 1 && (
                      <motion.div
                        style={isBack ? { x: -200, opacity: 0 } : { x: 200, opacity: 0 }}
                        animate={
                          isBack
                            ? { translateX: 200, opacity: 1 }
                            : { translateX: -200, opacity: 1 }
                        }
                        className="my-16"
                      >
                        <div className="h-40">section 0</div>
                        <button
                          onClick={() => changeSection(2, false)}
                          className="w-32 h-10 bg-black text-white rounded-lg text-xl"
                        >
                          Continue
                        </button>
                      </motion.div>
                    )}

                    {section === 2 && (
                      <motion.div
                        transition={500}
                        style={isBack ? { x: -200, opacity: 0 } : { x: 200, opacity: 0 }}
                        animate={
                          isBack
                            ? { translateX: 200, opacity: 1 }
                            : { translateX: -200, opacity: 1 }
                        }
                        className="my-16"
                      >
                        <div className="h-40">section 0</div>
                        <button
                          onClick={() => changeSection(3, false)}
                          className="w-32 h-10 bg-black text-white rounded-lg text-xl"
                        >
                          Continue
                        </button>
                      </motion.div>
                    )}
                  </div>
                </div> */}
                <div className="form-inner-section-below">
                <Formik
                  validationSchema={RegisterValidation}
                  initialValues={registerValues}
                  onSubmit={(values) => handleRegister(values)}
                >
                  {({  errors, touched }) => (
                    <Form>
                      <div className="top-firs-last-name flex flex-col gap-4">
                        <div className="first-name-section flex gap-4 justify-between">
                          <div className="left-image-upload-sec rounded-xl overflow-hidden h-28 relative w-[24%] bg-homeblack">
                            {profileImage == null ? 
                            <div className="added-image h-full w-full group">
                              <input type="file" name="" id="" className='h-full w-full opacity-0 relative z-40 cursor-pointer' onChange={(e) => handleImageChange(e)} />
                              <div className="inner-uploader bg-white bg-opacity-20 backdrop-blur-md rounded-full z-20 absolute bottom-2 duration-500 group-hover:bottom-[40%] left-2 right-2 px-4 py-1 flex items-center justify-center ">
                                <i className="bi bi-arrow-up text-sm text-white"></i>
                                <p className='text-white font-Manrope font-semibold text-center text-xs'> Upload</p>
                              </div>
                                <img src={ userProfile} className='h-full w-full  z-10 absolute object-cover top-0 left-0'  alt="" />
                            </div> :
                            <div className="uploaded-image h-full w-full">
                                <input type="file" name="" id="" className='h-full w-full opacity-0 relative z-40 cursor-pointer' onChange={(e) => handleImageChange(e)} />
                                <div className="inner-uploader bg-white rounded-full z-20 absolute bottom-2 shadow-xl left-2 right-2 px-4 py-1 flex items-center justify-center ">
                                  <i className="bi bi-arrow-repeat text-homeblack mr-2"></i>
                                  <p className='text-homeblack font-Manrope font-semibold text-center text-xs'> Change</p>
                                </div>
                              <img src={profileImage } className='h-full w-full  z-10 absolute object-cover top-0 left-0'  alt="" />
                            </div> }
                          </div>
                          <div className="top-form-name-section grid grid-cols-2 gap-4 w-[74%]">
                            <div className="email-section col-span-2">
                              <div className="form-inputsec relative">
                                <Field type="text" name="userName" placeholder='User Name'
                                  className={`outline-none border focus:border-greenYellow focus:bg-greenYellow focus:bg-opacity-10 duration-300 py-3 px-5 rounded-lg bg-transparent font-Manrope w-full text-homeblack font-semibold ${errors.userName && touched.userName ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500 text-red-500' : 'text-homeblack font-semibold border-homeblack border-opacity-70 placeholder:text-homeblack'}`} 
                                />
                              </div>
                            </div>
                            <div className="email-section col-span-2">
                              <div className="form-inputsec relative rounded-lg overflow-hidden">
                                <Field type="text" name="mobileNumber" placeholder='Mobile Number' onKeyPress={(e) => numbersOnlyInput(e)} maxLength={10}
                                  className={`outline-none border focus:border-greenYellow focus:bg-greenYellow focus:bg-opacity-10 duration-300 py-3 pr-5 pl-[70px] rounded-lg bg-transparent font-Manrope w-full text-homeblack font-semibold ${errors.mobileNumber && touched.mobileNumber ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500 text-red-500' : 'text-homeblack font-semibold border-homeblack border-opacity-70 placeholder:text-homeblack'}`} 
                                />
                                <div className="nineone-text absolute h-full left-0 top-0 rounded-l-lg border-r border-r-homeblack border-opacity-30 flex items-center justify-center w-14">
                                  <p className='text-homeblack font-Manrope font-semibold '>+91</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="password-email-branch grid grid-cols-2 col-span-2 gap-4">
                          <div className="email-section">
                            <div className="w-full form-inputsec relative">
                              <Field type="email" name="email" placeholder='Email'
                                className={`outline-none border focus:border-greenYellow focus:bg-greenYellow focus:bg-opacity-10 duration-300 py-3 px-5 rounded-lg bg-transparent font-Manrope w-full text-homeblack font-semibold ${errors.email && touched.email ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500 text-red-500' : 'text-homeblack font-semibold border-homeblack border-opacity-70 placeholder:text-homeblack'}`} 
                              />
                            </div>
                          </div>
                          <div className="email-section">
                            <div className="w-full form-inputsec relative">
                              <Field type={passwordHandler ? 'text' : 'password'} name="password" placeholder='Password'
                                className={`outline-none border focus:border-greenYellow focus:bg-greenYellow focus:bg-opacity-10 duration-300 py-3 px-5 rounded-lg bg-transparent font-Manrope w-full text-homeblack font-semibold ${errors.password && touched.password ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500 text-red-500' : 'text-homeblack font-semibold border-homeblack border-opacity-70 placeholder:text-homeblack'}`} 
                              />
                              <div className="absolute-icon left-side-contact absolute top-[10px] right-4">
                                  <button type='button' onClick={() => setPasswordHandler(!passwordHandler)}><i className={`bi ${passwordHandler ? 'bi-eye-slash' : 'bi-eye'} text-xl text-homeblack`}></i></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bottom-form-submitter mt-6 rounded-lg overflow-hidden relative group">
                          <button type='submit' className='w-full py-3 px-4 rounded-lg font-DmSans text-homeblack bg-greenYellow font-semibold hover:bg-hometext-homeblack hover:text-homeblack text-lg duration-500'>Register</button>
                      </div>
                    </Form>
                  )}
                </Formik>
                  <div className="bottom-already-section mt-2">
                    <div className="already-text-button">
                      <p className='text-sm font-Manrope text-homeblack '>Already Have an Account? <button type="button" className='font-semibold text-homePrimary text-base ml-2' onClick={() => navigate('/login')}>Login</button></p>
                    </div>
                  </div>
                </div>
            </div> : 
            <div className="inner-form-section-otp-login max-w-[80%] w-full py-10">
              <button type='button' onClick={() => setOtpHandler(false)} className="change-mail flex items-center gap-3 rounded-full bg-greenYellow px-4 py-1 w-fit">
                <i className="bi bi-arrow-left text-sm text-homeblack"></i>
                <p className='text-homeblack font-Manrope text-sm font-semibold'>Back</p>
              </button>
                <div className="top-header-login mb-10">
                  <h2 className='text-homeblack text-6xl font-DmSans leading-normal font-bold mb-0'>Enter OTP</h2>
                  <p className='text-homeblack font-DmSans'>We've sent an OTP code to <strong className='text-homePrimary'>{userMail ? userMail : 'Entered Mail'}</strong></p>
                </div>
                <div className="otp-input-section w-fit">
                  <p className='text-sm text-homeblack font-Manrope font-semibold mb-2'>Please Enter OTP</p>
                  <OTPInput value={otpInput} onChange={setOtpInput} autoFocus OTPLength={6} otpType="number" disabled={false} secure />
                  <div className="bottom-resender mt-2 text-right">
                    {resendToggle ? <button type="button" onClick={handleResend} className='text-homePrimary font-semibold font-DmSans text-right'>Resend OTP</button> :<p className='text-homeblack font-DmSans text-end'><strong className='text-orange-600'>0:{timeLeft} sec</strong> to resend OTP</p>}
                  </div>
                  <div className="bottom-form-submitter mt-6 rounded-lg overflow-hidden relative group">
                      <button type='button' onClick={() => otpHandleFetch()} disabled={otpInput.length > 5 ? false : true} className='w-full py-3 px-4 rounded-lg font-DmSans text-homeblack bg-greenYellow font-semibold hover:bg-hometext-homeblack hover:text-homeblack text-lg duration-500'>Register</button>
                  </div>
                </div>
                
            </div>
          }
        </div>
      </div>      
    </div>
  )
}


export default Register;
